'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from 'next-auth/react';
import { useState } from 'react';
import { ToastProvider } from '@/components/ui';
import PushNotificationProvider from '@/components/PushNotificationProvider';

export default function Providers({ children }: { children: React.ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { staleTime: 15_000, refetchOnWindowFocus: false },
        },
      })
  );

  return (
    <SessionProvider>
      <QueryClientProvider client={client}>
        <ToastProvider>
          <PushNotificationProvider>{children}</PushNotificationProvider>
        </ToastProvider>
      </QueryClientProvider>
    </SessionProvider>
  );
}
